<template>
  <div v-if="users.length">
    <Container class="flex pdg0">
      <div class="flex-shrink-0 directories__list">
        <section class="mrg">
          <ListStacked size="small">
            <li>
              <div class="flex align-items-center">
                <h1 class="h3 mrgv0">
                  {{ $t('directories.title') }}
                </h1>

                <Btn variant="icon" class="mrgl-" @click="isOpen = !isOpen">
                  <Icon id="help" :scale="0.75" />
                </Btn>
              </div>
            </li>

            <li>
              <Input
                v-model="filter"
                class="pdg--"
                @input="filter => updateDirectoriesFilter(filter)"
              />
            </li>
          </ListStacked>
        </section>

        <section>
          <ListStacked size="tight" divided class="list-stacked--dark">
            <li v-for="directory in directories(filter)" :key="directory.id">
              <Directory
                :directory="directory"
                :selected="directory.id == selectedDirectoryId"
                @select="handleSelect"
              />
            </li>
          </ListStacked>

          <Btn variant="link" @click="createDirectory()">
            <Icon id="add" :scale="0.6" />
            {{ $t('directories.add.title') }}
          </Btn>
        </section>
      </div>

      <div class="flex-fill pdg+">
        <template
          v-if="currentDirectory && currentDirectory.entries && !loading"
        >
          <h1>
            <template v-if="currentDirectory.is_global" 0>
              {{ $t('directories.directory.global-directory') }}
            </template>
            <template v-else>
              <Input v-model="currentDirectory.name" @blur="applyName" />
            </template>
          </h1>

          <section class="mrgb+">
            <DirectoryEntry :directory="currentDirectory" />
          </section>

          <section v-if="currentDirectory.entries.length">
            <DirectoryEntries :directory="currentDirectory" />
          </section>

          <section
            v-else
            class="flex flex-column align-items-center justify-content-center"
          >
            <h2 class="h3 mrgb+">
              {{ $t('directories.directory.empty') }}
            </h2>
            <img :src="emptyDirectoryImage" />
          </section>
        </template>

        <template v-else-if="loading">
          <Loader />
        </template>

        <DirectoryDelete />
      </div>
    </Container>

    <CDialog v-model="isOpen">
      <header class="dialog-header align-items-center">
        <div class="flex-fill">
          <h1 class="h4 mrgv0">
            {{ $t('directories.directory.help.title') }}
          </h1>
        </div>

        <Btn variant="icon" @click="isOpen = !isOpen">
          <Icon id="close" :scale="0.75" />
        </Btn>
      </header>

      <div class="dialog-body justify-content-center">
        <i18n path="directories.directory.help.content">
          <img
            src="@/assets/images/houston_repertoire.png"
            class="directory-img"
          />
        </i18n>
      </div>
    </CDialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import Directory from '@/components/directory/Directory.vue';
import DirectoryEntry from '@/components/directory/DirectoryEntry.vue';
import DirectoryEntries from '@/components/directory/DirectoryEntries.vue';
import DirectoryDelete from '@/components/directory/DirectoryDelete.vue';
import Loader from '@/components/ui/Loader';
import Input from '@/components/forms/fields/Input.vue';

export default {
  components: {
    Directory,
    DirectoryEntry,
    DirectoryEntries,
    DirectoryDelete,
    Loader,
    Input,
  },

  data() {
    return {
      isOpen: false,
      selectedDirectoryId: null,
      filter: '',
    };
  },

  computed: {
    ...mapState({
      users: state => Object.values(state.users.index),
      loading: state => state.directories.loading,
    }),
    ...mapGetters('directories', {
      currentDirectory: 'getCurrentDirectory',
    }),
    ...mapGetters('directories', {
      directories: 'getDirectories',
    }),

    emptyDirectoryImage() {
      return require('@/assets/images/directory.svg');
    },
  },

  watch: {
    '$route.params.id': {
      handler(directoryId) {
        this.loadDirectory(directoryId);
      },
    },
  },

  created() {
    this.loadDirectory(this.$route.params.id);
  },

  mounted() {
    this.$store.dispatch('directories/getDirectories');
  },

  methods: {
    handleSelect(directoryId) {
      this.$router.push(`/directories/${directoryId}`).catch(() => {});
    },
    updateDirectoriesFilter(filter) {
      this.filter = filter;
    },
    loadDirectory(directoryId) {
      if (directoryId) {
        this.selectedDirectoryId = directoryId;
        this.$store.dispatch('directories/getDirectory', {
          directoryId: this.$route.params.id,
        });
      } else {
        this.selectedDirectoryId = null;
        this.$store.dispatch('directories/unselectDirectory');
      }
    },
    createDirectory() {
      this.filter = '';
      this.$store
        .dispatch('directories/createDirectory', {
          directoryName: null,
        })
        .then(response => {
          this.$store.dispatch('directories/getDirectories');
          this.$router.push(`/directories/${response.data.id}`);
        });
    },
    applyName() {
      this.$store.dispatch(
        'directories/updateDirectory',
        this.currentDirectory
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.directory-img {
  width: 100%;
}

.directories__list {
  width: 375px;
  background-color: rgba($alt-50, 0.75);

  border-right: $list-separator-style-dark;

  .list-stacked--divided {
    border-top: $list-separator-style-dark;
    border-bottom: $list-separator-style-dark;
  }
}
</style>
